import { AmbientLight, Color, DirectionalLight, PerspectiveCamera, PointLight, Scene, WebGLRenderer } from "three";
import { GraphicsContext } from "./GraphicsContext";

export class PerspectiveContext extends GraphicsContext {

    public perspectiveCamera = () => this.camera as PerspectiveCamera;

    resizeCanvasToDisplaySize() {
        const canvas = this.renderer.domElement;
        const width = this.containerElement.clientWidth;
        const height = this.containerElement.clientHeight;

        if (canvas.width !== width || canvas.height !== height) {
            this.renderer.setSize(width, height, true);
            this.perspectiveCamera().aspect = width / height;
            this.perspectiveCamera().updateProjectionMatrix();
        }
    }

    static createDefault(containerElement: HTMLElement): PerspectiveContext {
        let width = containerElement.clientWidth;
        let height = containerElement.clientHeight;
        const scene = new Scene();
        scene.background = new Color(0xffffff);

        const aspectRatio = width / height;
        const camera = new PerspectiveCamera(40, aspectRatio, 0.1, 1000);
        camera.translateZ(2).translateY(1);

        camera.position.z = 5;

        const renderer = new WebGLRenderer({antialias: true});
        renderer.setSize(width, height);
        renderer.shadowMap.enabled = true;
        containerElement.appendChild(renderer.domElement);

        // LIGHTS
        let ambientLight = new AmbientLight( 0xffffff, 1 );

        let light = new DirectionalLight( 0xFFffff, 1 );
        light.castShadow = true;
        light.shadow.bias = 0.0004;
        light.position.set( -0.32, 0.39, -0.7 );

        const light2 = new PointLight( 0xffffff, 2, 35 );
        light2.position.set( 1, 1.5, 2 );
        light2.castShadow = true;
        scene.add( light2 );

        scene.add(ambientLight);

        const graphicsContext = new  PerspectiveContext(scene, camera, renderer, containerElement);

        return graphicsContext;
    }
    
}